import React from "react";
import { useAppSelector } from "../../redux/store";
import { DesktopFooter } from "./blocks/desktop-footer";
import { MobileFooter } from "./blocks/mobile-footer";
import { TabletFooter } from "./blocks/tablet-footer";

const Component = () => {
  const { matchesPhone, matchesTablet, matchesPc } = useAppSelector(
    (state) => state.deviceReducer,
  );
  
  if (matchesPhone) {
    return <MobileFooter />;
  } else if (matchesTablet) {
    return <TabletFooter />;
  } else {
    return <DesktopFooter />;
  }
};

export const Footer = React.memo(Component);
